// ./src/refusedNewInputs.ts — telling a gateway that does not know a new INPUT field apart from any other failure.
import type { OpResult } from "@sdflc/api-helpers";

import { errorMessages } from "./opResultHelpers";

/**
 * The gateway refused an INPUT field it does not know yet (an API or gateway deployed after the site) — the read is
 * retried without them, so a deploy in the wrong order costs the new behaviour, never the page (review 2026-10-04: an
 * invitation link would otherwise 404 the whole event site).
 */
export const refusedNewInputs = (result: OpResult, fields: string[]): boolean =>
  !result.didSucceed() &&
  new RegExp(`Field ["']?(${fields.join("|")})["']? is not defined by type`).test(errorMessages(result).join("\n"));

